import React, { useEffect, useState } from "react";
import { v4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { getUserById, logout, selectUser } from "../redux/users/usersSlice";
import { getCompanyById,selectCompany} from '../redux/company/companySlice'
import {
  createSubmission,
  getSubmission,
  getSubmissionStatus,
} from "../utils/api/submissions";

const DynamicForm = () => {
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState({});
  const [popupVisible, setPopupVisible] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState("pending");
  const [submissionMessage, setSubmissionMessage] = useState('');
  const [intervalId, setIntervalId] = useState(null); 
  let instanceId = v4();
  const user = useSelector(selectUser);
  const company = useSelector(selectCompany);
  useEffect(() => {
    dispatch(getUserById());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getCompanyById(user?.company));
  }, [user?.company,dispatch]);

  const form = company?.form;
  const companyName = company?.name;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
   
  const handleSubmit = async (e) => {
    e.preventDefault();
    setPopupVisible(true);
     setSubmissionStatus("pending");

     if (intervalId) {
       clearInterval(intervalId);
       setIntervalId(null);
     }

    try {
      const values = Object.keys(formValues).map((key) => ({
        fieldName: key,
        fieldValue: formValues[key],
      }));
      const response = await createSubmission({
        companyId: user.company,
        employeeId: user.id,
        response: values,
        instanceId: instanceId
      });
      let attempt = 0;
      const pollSubmissionStatus = async () => {
        if(company.isBypass){
          attempt++;
          if(attempt > 5){
            clearInterval(intervalId);
            setSubmissionStatus('success');
            setSubmissionMessage('Submission Success');
            return;
          }
        }
        const statusResponse = await getSubmission(
          response.data.data.id
        );
        setSubmissionMessage(statusResponse.data.data.message ?? '');
        setSubmissionStatus(statusResponse.data.data.status);

      };

      const interval = setInterval(pollSubmissionStatus, 3000);
      setIntervalId(interval);
    } catch (err) {
      console.log(err);
    }

    setFormValues({});
  };

   const onSuccess = () => {
     clearInterval(intervalId);
     setPopupVisible(false);
     setIntervalId(null);
   };


  return (
    <div className="flex flex-col items-center h-screen justify-center min-h-screen px-4 py-10 sm:px-6 lg:px-8 bg-gray-50">
      <div className="w-full max-w-md p-8 space-y-8 overflow-y-auto bg-white rounded-lg shadow-md">
        {/* <h1 className="text-3xl font-bold text-gray-900">
          Please fill the form
        </h1> */}

        {form && (
          <form
            onSubmit={(e) => handleSubmit(e, form.name)}
            className="grid grid-cols-1 gap-1 mt-4 space-y-6 sm:grid-cols-2"
          >
            <div className="flex items-center justify-center py-1 gap-2  col-span-full">
            {/* <h2 className="text-xl text-gray-700">
              Name of the form:
            </h2> */}
            <h2 className="text-3xl font-bold">{form.name} </h2>
            </div>

            {form.fields.map((field, fieldIndex) => {
              return (
                <div className="mb-4" key={fieldIndex}>
                  <label className="block mb-1 text-sm font-medium text-gray-700">
                    {field?.label}
                  </label>

                  {field?.type === "dropdown" ? (
                    <select
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-indigo-500"
                      name={field.name}
                      value={formValues[`${field.name}`] || ""}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select an option</option>
                      {field?.options?.map((option, optionIndex) => (
                        <option key={optionIndex} value={option}>
                          {option}
                        </option>
                      ))}
                    </select>
                  ) : (
                    <input
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring focus:ring-indigo-500"
                      type={field?.type}
                      name={field.name}
                      placeholder={field?.placeholder || ""}
                      value={formValues[`${field.name}`] || ""}
                      onChange={handleChange}
                      required
                    />
                  )}
                </div>
              );
            })}

            <div className="text-right col-span-full">
              <button
                className="w-full px-5 py-2 font-semibold text-white bg-indigo-600 rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                type="submit"
              >
                Submit
              </button>
            </div>
          </form>
        )}

        <div
          className="flex justify-center py-2 text-white bg-black rounded-lg cursor-pointer item-center"
          onClick={() => dispatch(logout())}
        >
          Logout
        </div>
      </div>

      {popupVisible && (
        <div className="fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="relative w-full max-w-sm p-8 transition-transform duration-300 ease-in-out transform scale-105 bg-white rounded-lg shadow-xl">
            <div className="absolute top-2 right-2">
              {/* <button
                className="text-gray-500 transition duration-200 hover:text-gray-700"
                onClick={() => setPopupVisible(false)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button> */}
            </div>
            <h2 className="mb-4 text-xl font-bold text-center text-gray-800 capitalize">
              Form Status: {submissionStatus}
            </h2>

            {submissionStatus === "success" ? (
              <div className="text-center">
                <p className="font-semibold text-green-600">
                  Your submission is complete!
                </p>
                <div className="font-semibold text-gray-600" style={{whiteSpace: 'pre-line'}}>
                {submissionMessage}
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-12 h-12 mx-auto mt-4 text-green-500"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>

                <div onClick={()=>onSuccess()} className="bg-green-700 text-white rounded-md p-2 cursor-pointer">Ok</div>
              </div>
            ) : (
              <div className="flex flex-col items-center">
                <p className="mb-4 font-semibold text-yellow-600">
                  Processing...
                </p>
                <div className="font-semibold text-gray-600" style={{whiteSpace: 'pre-line'}} dangerouslySetInnerHTML={{ __html: submissionMessage}}>
                </div>
                <div className="w-8 h-8 border-4 border-t-4 border-yellow-300 rounded-full border-t-yellow-500 animate-spin"></div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DynamicForm;
